export const routes = {
  supplier: {
    assessments: '/supplier/assessments',
    assessment: (id: string) => `/supplier/assessments/${id}`,
    assessmentPage: (id: string, section: string, page: number) => `/supplier/assessments/${id}/${section}?page=${page}`,
    opportunities: '/supplier/opportunities',
    opportunity: (id: string) => `/supplier/opportunities/${id}`,
    growth: '/supplier/growth',
    profile: '/supplier/profile',
    userInfo: '/supplier/user-info',
    settings: '/supplier/settings',
    reports: '/supplier/reports',
    dashboard: '/supplier',
  },
  registration: {
    supplier: '/registration/supplier',
    supplierInvite: '/registration/supplier/invite',

  },
  champion: {
    dashboard: '/champion',
    profile: '/champion/profile',
    settings: 'champion/settings',
  },
  onboarding: {
    champion: '/onboarding/champion',
  },
  landing: {
    root: '/landing',
    suppliers: '/landing/suppliers',
    pricing: '/landing/pricing',
    about: '/landing/about',
    enterprises: '/landing/enterprises',
    supplierRegistration: '/landing/suppliers/registration',
  },
  admin: {
    dashboard: '/admin',
    users: '/admin/users',
    suppliers: '/admin/suppliers',
    supplier: (id: string) => `/admin/suppliers/${id}`,
    user: (id: string) => `/admin/users/${id}`,
    supportTickets: '/admin/support-tickets',
    supportTicket: (id: string) => `/admin/support-tickets/${id}`,
    feedback: '/admin/feedback',
    feedbackSubmission: (id: string) => `/admin/feedback/${id}`,
    registrations: '/admin/registrations',
    registrationCodes: '/admin/registration-codes',
    registrationCode: (code: string) => `/admin/registration-codes/${code}`,
  },
  privacyPolicy: '/privacy-policy',
};
